/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var InfoCircleIcon20Regular = forwardRef('InfoCircleIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M9.268 8.945a.75.75 0 1 0 0 1.5h.25v2.043H9a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-.482V9.695a.75.75 0 0 0-.75-.75h-1Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.001 10A7.999 7.999 0 1 1 18 10 7.999 7.999 0 0 1 2 10Zm8-6.499A6.499 6.499 0 1 0 10 16.5 6.499 6.499 0 0 0 10 3.5Z" })));
});
